export default "__VITE_ASSET__29a47c03__"